import { SVGProps } from 'react';
const SvgMoveHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 12h18M18 9l3 3-3 3M6 15l-3-3 3-3"
    />
  </svg>
);
export default SvgMoveHorizontal;
